import tokens from "./tokens";

function createInput(name, value, form) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
}

function addCSRFToken(form) {
    let tokenParamName = tokens.getTokenParamName();
    let token = tokens.getToken();
    createInput(tokenParamName, token, form);
}

export default function (url, params, method = 'get') {
    const windowOption = 'resizable=yes,location=0,menubar=0,scrollbars=1';
    const form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', '' + url);
    form.setAttribute('target', 'Download');
    const keys = Object.keys(params);
    for (const i in keys) {
        let name = keys[i];
        if (params.hasOwnProperty(name)) {
            let value = params[name];
            createInput(name, value, form);
        }
    }

    addCSRFToken(form);

    document.body.appendChild(form);
    window.open('', 'Download', windowOption);
    form.target = 'Download';
    form.submit();
    document.body.removeChild(form);
};
